<template>
  <div>
    <div class='wrapper'>
      <div v-for='room in rooms' :key='room.id'>
        <div class='site'>
          <p>{{ room.room }}</p>
          <a @click='deleteRoom(room)'>Delete</a>
        </div>
      </div>
      <RoomForm/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RoomForm from '@/components/Room/RoomForm.vue'

export default {
  name: 'Room',
  computed: {
    ...mapGetters(['rooms'])
  },
  components: {
    RoomForm
  },
  created () {
    this.$store.dispatch('getRooms', this.$route.params.id)
  },
  methods: {
    deleteRoom (room) {
      this.$store.dispatch('deleteRoom', room)
    }
  }
}
</script>

<style scoped>
.site {
  border: 3px solid;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
}

.site p:first-child {
  font-weight: bold;
  font-size: 2.5rem;
  margin: 1rem 0;
}

.site p:last-child {
  font-style: italic;
  font-size: 0.8rem;
}
</style>
